define('controls',['jquery', 'core', 'html5Upload', 'isotope', 'bridget', 'zebraDatepicker', 'pointerEvents', 'selectize'], function ($, core, html5Upload, isotope) {
    var module = {};

    $.bridget('isotope', isotope);

    module.attach = function (context) {
        module.onBcmsCafeAdminPageLoad(context);
        module.initializeProfilePictureUpload(context);
        module.initShowMore(context);
        module.showHidePostFromAboutPage(context);
        module.integerNumbersOnly(context);
        module.onReceiveNewsClick(context);
        module.onUploadPhotoButtonClick(context);
        module.checkoutMode(context);
        module.socialLoginAndRegister(context);
        module.checkoutPaymentMethodSelect(context);
        module.requestSizeConfirmation(context);
        module.shareLinkToOutfit(context);
        module.bindDatePicker(context);
        module.inPageNavDropDown(context);
        module.filterTabs(context);
        module.initPointerEventsPolyfill();
        module.customSelect(context);
        module.fixFixed(context); /* fix for an ipad */
    };

    module.onBcmsCafeAdminPageLoad = function (context) {
        if (context.andFind('.js-cafe-page-admin').length) {
            var tries = 0;
            var intervalId = setInterval(function () {
                if (tries < 200) {
                    if ($('.bcms-sidemenu').length) {
                        clearInterval(intervalId);

                        $('.bcms-btn-add').remove();
                        $('.bcms-btn-clone').remove();

                        $('.bcms-btn-blog-add').remove();
                        $('.bcms-btn-settings').remove();
                        $('.bcms-btn-delete').remove();
                    }
                } else {
                    clearInterval(intervalId);
                }
                tries++;
            }, 50);
        }
    };

    module.initializeProfilePictureUpload = function (context) {
        if (context.andFind('.js-user-picture').length) {
            var lockContext;

            html5Upload.initialize({
                uploadUrl: $('.js-user-picture').data('upload-url'),
                maxFileSize: 10 * 1024 * 1024,
                inputField: document.getElementById('js-upload-input'),
                maxSimultaneousUploads: 1,
                onFileAdded: function (file) {
                    file.on({
                        onStart: function () {
                            lockContext = core.ui.lock('container', $(".js-user-picture"));
                        },
                        onCompleted: function (response) {
                            var jsonResponse = jQuery.parseJSON(response);
                            if (jsonResponse.Success) {
                                $('.js-user-picture > img')[0].src = jsonResponse.FileUri;
                                $('.js-user-picture').removeClass('empty');
                            } else {
                                core.ui.alert({ title: "Error", message: jsonResponse.Message });
                            }
                            core.ui.unlock(lockContext);
                            lockContext = undefined;
                        }
                    });
                }
            });
        }
    };

    module.initShowMore = function (context) {
        var feed = context.andFind('.js-feed-list');

        var $grid = feed.isotope({
            itemSelector: '.item',
            percentPosition: true,
            layoutMode: 'masonry'
        });

        context.andFind('.js-populatemore').each(function () {
            var control = $(this),
                mainContainer = $('.history-list-container'),
                url = control.data('url'),
                container = context.relativeFind(control.data('container')),
                insertPoint = container.find(control.data('insertBefore')),
                fetchList = core.decode.list(control.data('fetchList')),
                fetchCount = control.data('fetchCount'),
                endMessage = control.data('endMessage'),
                position = 0,
                fadeDelay = 500;
            control.on('click', function (e, prefetch) {
                e.preventDefault();
                var itemIds = [];
                for (var i = 0; i < fetchCount && position < fetchList.length; i++) {
                    itemIds.push(fetchList[position++]);
                }
                $.ajax(url, {
                    type: 'POST',
                    data: 'itemIds=' + itemIds.join(',')
                }).done(function (response) {
                    if (response && response.Success) {

                        var content = $(response.Content),
                            isVisible = !prefetch && container.is(':visible');
                        // TODO: Fetch items until fetch count is reached
                        if (isVisible) {
                            content.css({ opacity: 0 });
                        }
                        if (position >= fetchList.length) {
                            if (endMessage) {
                                control.parent().replaceWith(endMessage);
                            } else {
                                control.hide();
                                mainContainer.addClass('end-reached');
                            }
                        }
                        var scrollTo;
                        if (insertPoint.length > 1) {
                            scrollTo = insertPoint.offset().top;
                            content.insertBefore(insertPoint).isotope('appended', content);
                        } else {
                            container.append(content).isotope('appended', content);
                            scrollTo = content.first().offset().top;
                        }

                        if (isVisible) {
                            $("html, body").animate({ scrollTop: scrollTo - 10 }, fadeDelay);
                            for (var ii = 0; ii < content.length; ii++) {
                                content.eq(ii).delay(150 * ii).animate({ opacity: 1 }, fadeDelay);
                            }
                        }
                        core.scopes.update(content);
                    }
                }).fail(function (response) {
                    module.handleAjaxError(response, url);
                });
            });
        });
    };

    module.showHidePostFromAboutPage = function (context) {
        context.andFind('.js-show-hide-post').click(function () {
            var self = $(this),
                show = self.data('show'),
                id = self.data('id');

            self.data('show', !show);
            self.attr("data-show", !show ? "true" : "false");
            self.parents(".js-history-article").toggleClass("feed-item-hidden");

            var form = $('.js-feed-status-change-form');
            form.andFind('.js-feed-id').val(id);
            form.andFind('.js-feed-status').val(!show ? "True" : "False");
            form.submit();
            return false;
        });
    };

    module.integerNumbersOnly = function (context) {
        context.find('.js-integer-numbers').keyup(function (e) {
            var self = $(this);
            this.value = this.value.replace(/[^0-9]/g, '');
            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });
    };

    module.onReceiveNewsClick = function (context) {
        context.andFind('.js-receive-news').click(function () {
            var self = $(this),
                receiveNews = self[0].checked;

            context.andFind('.js-receive-news-hidden-check-box').val(receiveNews);
            context.andFind('.js-receive-news-form').submit();
        });
    };

    module.onUploadPhotoButtonClick = function (context) {
        context.andFind('.js-button-upload-photo').click(function () {
            var photoInputField = context.context.getElementById('js-upload-input');
            photoInputField.click();
        });
    };

    module.requestSizeConfirmation = function (context) {
        context.andFind('.js-request-size').on('click', function (e) {
            e.preventDefault();

            var itemId = $('.js-request-size-dropdown').val();
            var size = $('.js-request-size-text-item-id-' + itemId).text();
            var messagesContainer = $('.js-request-form > .js-messages');
            var $sizeForm = $('.js-request-form');
            var isFormValid = $sizeForm.valid();

            if (itemId && itemId != "0") {
                core.ui.showMessages(messagesContainer, undefined);
                if (isFormValid) {
                    $('.js-request-size-desired-size').val(size);
                    $sizeForm.submit();
                }
            } else {
                $('.js-request-size-desired-size').val('');
                core.ui.showMessages(messagesContainer, ["Please select desired size."]);
            }
        });
    }

    module.checkoutMode = function (context) {
        context.andFind('.js-restore-cookie').on('click', function (e) {
            e.preventDefault();

            core.cookie.remove(window.portal.settings.constants.checkoutCookieName);
            core.ui.lock('screen', undefined, true);

            window.location = $(this).attr('href');
        });

        context.andFind('.js-checkout-as-guest').on('click', function (e) {
            e.preventDefault();

            core.cookie.put(window.portal.settings.constants.checkoutCookieName, window.portal.settings.constants.checkoutAsGuest);
            core.ui.lock('screen', undefined, true);

            window.location = $(this).attr('href');
        });
    }

    module.socialLoginAndRegister = function (context) {
        context.andFind('.js-social-action').on('click', function (e) {
            e.preventDefault();
            core.ui.lock('screen');
            var setCheckoutUrl = $(this).data('set-checkout-url'),
                setDressingRoomUrl = $(this).data('set-dressing-url'),
                unsetCustomUrl = $(this).data('unset-custom-url'),
                href = $(this).attr('href');

            if ($('.js-login-checkout-mode').val() == "True") {
                $.ajax({
                    type: 'POST',
                    url: setCheckoutUrl
                }).then(function () {
                    window.location.href = href;
                }, function () {
                    window.location.href = href;
                });
            } else if ($('.js-login-dressing-room-mode').val() == "True") {
                $.ajax({
                    type: 'POST',
                    url: setDressingRoomUrl
                }).then(function () {
                    window.location.href = href;
                }, function () {
                    window.location.href = href;
                });
            } else {
                $.ajax({
                    type: 'POST',
                    url: unsetCustomUrl
                }).then(function () {
                    window.location.href = href;
                }, function () {
                    window.location.href = href;
                });
            }
        });
    }

    module.checkoutPaymentMethodSelect = function (context) {
        function selectActiveButton(button) {
            $('.js-payment-method').removeClass('button-primary').addClass('button-secondary');
            button.removeClass('button-secondary').addClass('button-primary');
        }

        context.andFind('.js-pay-with-paypal, .js-pay-with-new-card').click(function (e) {
            e.preventDefault();
            var self = $(this);

            var paymentMethod = self.data('payment-method');
            $('.js-checkout-selected-payment-method').val(paymentMethod);
            $('.js-checkout-selected-payment-profile-id').val(0);

            selectActiveButton(self);
        });


        context.andFind('.js-pay-with-existing-card').click(function (e) {
            e.preventDefault();
            var self = $(this);

            var paymentProfileId = self.data('payment-profile-id');
            $('.js-checkout-selected-payment-profile-id').val(paymentProfileId);

            var selectedPaymentMethodInput = $('.js-checkout-selected-payment-method');
            selectedPaymentMethodInput.val(selectedPaymentMethodInput.data('default-value'));

            selectActiveButton(self);
        });
    }

    module.shareLinkToOutfit = function (context) {
        var self,
            shareWrapper;
        $('a.js-share-link', context).on('click', function (e) {
            e.preventDefault();
            self = $(this);
            shareWrapper = self.closest('.dressing-room-share-wrapper');
            if (self.hasClass('share-active')) {
                self.removeClass('share-active').text(self.data('sharetext'));
                shareWrapper.removeClass('share');
            } else {
                self.addClass('share-active').text(self.data('closeshare'));
                shareWrapper.addClass('share');
            }
            $('.js-shared-link', context).show().select();
        });
    }

    module.bindDatePicker = function (context) {
        context.andFind(".js-datepicker").Zebra_DatePicker({
            readonly_element: true,
            show_select_today: true,
            show_clear_date: true,
            format: "m/d/Y",
            direction: [true, true],
            offset: [-120, 270]
        });
    };

    module.inPageNavDropDown = function (context) {
        var toggle = context.andFind('.js-in-page-navigation-toggle'),
            inPageNav,
            navItems,
            thisHref;

        if (toggle.length) {
            inPageNav = toggle.closest('.js-in-page-navigation');
            navItems = inPageNav.find('ul').find('a');

            navItems.each(function () {
                thisHref = $(this).attr("href");

                if (window.location.hash === thisHref) {
                    toggle.text($(this).text());
                }
            });

            toggle.on('click', function (e) {
                e.preventDefault();
                inPageNav.toggleClass("dropdown-is-open");
            });

            navItems.on('click', function () {
                inPageNav.removeClass("dropdown-is-open");
                toggle.text($(this).text());
            });
        }
    };

    module.initPointerEventsPolyfill = function () {
        PointerEventsPolyfill.initialize({
            selector: '.js-content-cover'
        });
    };

    module.customSelect = function (context) {
        var sizeSelector = context.andFind('.js-product-sizes-selectize');
        var sizeOptions = sizeSelector.find('option').map(function (index, option) {
            var $option = $(option);
            return {
                id: $option.val(),
                title: $option.text(),
                designerSizeText: $option.data('designer-size-text'),
                isDisabled: $option.prop('disabled')
            }
        });

        sizeSelector.removeClass('select-main');
        sizeSelector.selectize({
            valueField: 'id',
            options: sizeOptions,
            onDelete: function () { return false; },
            closeAfterSelect: true,
            render: {
                option: function (data, escape) {
                    return '<div class="option ' + (data.isDisabled ? 'option-disabled' : '') + '">' +
                            '<span class="real-size">' + escape(data.title) + '</span>' +
                            '<span class="designer-size">' + escape(data.designerSizeText) + '</span>' +
                        '</div>';
                },
                item: function (data, escape) {
                    return '<div class="option-selected">' +
                            '<span class="real-size data-id-' + data.id + '">' + escape(data.title) + '</span>' +
                            '<span class="designer-size">' + escape(data.designerSizeText) + '</span>' +
                        '</div>';
                }
            },
        });
        var input = 'selectize-input input';
        $(context).andFind('.' + input).attr('readonly', true);
    };

    module.fixFixed = function (context) {
        var $body = $('body'),
            focusableElements = $("input, select, textarea", context);
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            $(document).ready(function () {
                focusableElements.on('focus', function () {
                    $body.addClass('fixfixed');
                })
                focusableElements.on('blur', function () {
                    $body.removeClass('fixfixed');
                })
            });
        }
    };

    module.filterTabs = function (context) {
        var toggles = context.andFind('.js-tab-toggle'),
            tabs = context.andFind('.js-filters-tab');

        tabs.first().css("display", "block");
        toggles.first().addClass("active");

        toggles.on('click', function (e) {
            e.preventDefault();
            tabs
                .hide()
                .filter("[data-tab-index=" + $(this).data("tab-index") + "]")
                .show();
            toggles
                .removeClass("active")
                .filter("[data-tab-index=" + $(this).data("tab-index") + "]")
                .addClass("active");
        });
    };

    // Initialize
    $(document).ready(function () {
        core.scopes.addHandler('*', function (context) {
            module.attach(context);
        });
    });
});
